import React from 'react';
import { TooltipInput } from '../../../../config/goals';
import { Tooltip } from '../../../general/Tooltip';
import { TooltipIndicator } from '../../../general/TooltipIndicator';

export const GoalQuestionCard: React.FC<{
    iconPath?: string;
    question?: string;
    description?: string;
    icon?: React.ReactNode;
    children?: React.ReactNode;
    tooltip?: TooltipInput;
}> = ({ question, description, icon, children, tooltip }) => {
    return (
        <div className="flex flex-col md:flex-row items-center justify-between">
            {!!icon && (
                <div className="flex items-center justify-center mb-8 md:mb-0  w-24 h-24 shadow-2xl rounded-xl md:mr-12">
                    {icon}
                </div>
            )}
            <div className="flex flex-col flex-1 self-stretch">
                <div className="flex items-center mb-4">
                    {!!question && <span className="font-medium text-xl">{question}</span>}
                    {tooltip && (
                        <Tooltip
                            tooltipTitle={tooltip.tooltipTitle}
                            tooltipText={tooltip.tooltipText}
                            className="ml-2"
                            place="bottom"
                        >
                            <TooltipIndicator>?</TooltipIndicator>
                        </Tooltip>
                    )}
                </div>
                {!!description && <p className="mb-8 text-gray-800">{description}</p>}
                {children}
            </div>
        </div>
    );
};
